import React from 'react';
import { batch } from 'react-redux';
import styled from 'styled-components';
import {
  IBuilderFoldEvent,
  IRowMeta,
  removeErrorAction,
  removeReroutingEventAction,
  RowType,
} from '../../../../../redux/slices/oldBuilder';
import { EventCondition } from '../../EventConditions';
import { isEmptyEventCondition } from '../../../../../utils/builder';
import { useAppDispatch } from '../../../../../redux/hooks';
import { useActionsVisibilityContext } from '../../../../ActionsVisibilityContext';
import { useHighlightingContext } from '../../../../HighlightingContext';
import { byTypeName } from '../../../../../utils/types';
import { SquareRemoveButton } from '../../../../Button';

interface IProps {
  foldEvent: IBuilderFoldEvent;
  index: number;
}

const Container = styled.div`
  position: relative;
`;

const RemoveAction = styled(SquareRemoveButton)`
  position: absolute;
  top: 7px;
  right: 0;
`;

const FoldEventInput = ({ foldEvent, index }: IProps) => {
  const dispatch = useAppDispatch();

  const { eventCondition } = foldEvent;

  const rowMeta: IRowMeta = {
    rowType: RowType.foldEvents,
    rowIndex: index,
  };

  const { activateHighlighting, deactivateHighlighting } =
    useHighlightingContext();
  const { actionsVisible } = useActionsVisibilityContext();

  const handleRemove = () => {
    batch(() => {
      dispatch(removeErrorAction({ rowMeta, errorKey: '', clearRow: true }));
      dispatch(
        removeReroutingEventAction({
          index,
          type: RowType.foldEvents,
        }),
      );
    });
  };

  const virtualEvents = eventCondition?.events.filter(
    byTypeName('VirtualEvent'),
  );
  const canRenderFilters =
    !isEmptyEventCondition(eventCondition) && !virtualEvents?.length;

  return (
    <Container>
      <EventCondition
        rowMeta={rowMeta}
        label={'Fold Event(s)'}
        canRenderRemove={false}
        filter={eventCondition?.filter}
        canRenderFilters={canRenderFilters}
        placeholder={'Select event(s) to fold'}
      />
      {actionsVisible && (
        <RemoveAction
          onClick={handleRemove}
          content={'Remove Fold Event'}
          onMouseEnter={activateHighlighting}
          onMouseLeave={deactivateHighlighting}
        />
      )}
    </Container>
  );
};

export default FoldEventInput;
